var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuarterProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12Z",
    fill: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C9.46585 24 6.99675 23.1977 4.94658 21.7082C2.8964 20.2187 1.37042 18.1183 0.587321 15.7082C-0.195774 13.2981 -0.195774 10.7019 0.587322 8.29179C1.37042 5.88167 2.89641 3.78133 4.94658 2.29179C6.99675 0.802258 9.46585 -5.21123e-07 12 0C14.5342 5.21123e-07 17.0033 0.802261 19.0534 2.2918C21.1036 3.78133 22.6296 5.88168 23.4127 8.2918C24.1958 10.7019 24.1958 13.2981 23.4127 15.7082L17.7063 13.8541C18.0979 12.649 18.0979 11.351 17.7063 10.1459C17.3148 8.94084 16.5518 7.89067 15.5267 7.1459C14.5016 6.40113 13.2671 6 12 6C10.7329 6 9.49837 6.40113 8.47329 7.1459C7.4482 7.89067 6.68521 8.94084 6.29366 10.1459C5.90211 11.351 5.90211 12.649 6.29366 13.8541C6.68521 15.0592 7.4482 16.1093 8.47329 16.8541C9.49837 17.5989 10.7329 18 12 18L12 24Z",
    fill: "#516CD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarterProgress);
export default __webpack_public_path__ + "static/media/quarterProgress.30b66855bfe43ea7537b03ae40771d0a.svg";
export { ForwardRef as ReactComponent };